module.exports = __webpack_public_path__ + "img/CR06E.1d877a30.png";